<template>
<div class="invoice-modal">
    <v-card flat class="pa-3">
        <v-row no-gutters align="center">
            <v-col cols="12" md="4" offset-md="4" class="text-center">
                <div class="major font-weight-black">{{ getTitle(item.number) }}</div>
                <div class="important">{{ item.number }}</div>
            </v-col>
            <v-col cols="12" md="4" class="text-right">
                <div>Data emiterii: {{ formatDate(item.issued_at) }}</div>
                <div>Data scadenta: {{ formatDate(item.due_date) }}</div>
            </v-col>
        </v-row>
        <v-row class="my-2" no-gutters>
            <v-col cols="12" md="6">
                <div class="regular">
                    <div class="font-weight-bold pb-2">{{ item.merchant_info.name }}</div>
                    <v-row no-gutters>
                        <v-col cols="3">C.I.F. TVA:</v-col>
                        <v-col cols="9">{{ item.merchant_info.fiscal_code }}</v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="3">Reg. Com:</v-col>
                        <v-col cols="9">{{ item.merchant_info.registry_number }}</v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="3">Adresa:</v-col>
                        <v-col cols="9">
                            <span v-if="item.merchant_info.address.region">{{ item.merchant_info.address.region }}, </span> <span v-if="item.merchant_info.address.city">{{ item.merchant_info.address.city }},</span> {{ item.merchant_info.address.street }}
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="3">Banca:</v-col>
                        <v-col cols="9">{{ item.merchant_info.bank.name }}</v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="3">
                            <span v-if="$vuetify.breakpoint.smAndUp">Cont</span> IBAN:
                        </v-col>
                        <v-col cols="9" class="text-truncate">{{ item.merchant_info.bank.account }}</v-col>
                    </v-row>
                </div>
            </v-col>
            <v-col cols="12" md="6">
                <div class="regular">
                    <div class="font-weight-bold pb-2">{{ item.customer_info.name }}</div>
                    <v-row no-gutters>
                        <v-col cols="3">C.I.F. TVA:</v-col>
                        <v-col cols="9">{{ item.customer_info.fiscal_code }}</v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="3">Reg. Com:</v-col>
                        <v-col cols="9">{{ item.customer_info.registry_number }}</v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="3">Adresa:</v-col>
                        <v-col cols="9">
                            <span v-if="item.customer_info.address.region">{{ item.customer_info.address.region }}, </span> <span v-if="item.customer_info.address.city">{{ item.customer_info.address.city }},</span> {{ item.customer_info.address.street }}
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="3">Banca:</v-col>
                        <v-col cols="9">{{ item.customer_info.bank.name }}</v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="3">
                            <span v-if="$vuetify.breakpoint.smAndUp">Cont</span> IBAN:
                        </v-col>
                        <v-col cols="9" class="text-truncate">{{ item.customer_info.bank.account }}</v-col>
                    </v-row>
                </div>
            </v-col>
        </v-row>
        <div class="py-1">
            <v-row no-gutters class="pb-1 font-weight-bold">
                <v-col cols="4" md="6">Denumire Produs</v-col>
                <v-col cols="8" md="6">
                    <v-row no-gutters>
                        <v-col cols="3" class="text-center">Cant</v-col>
                        <v-col cols="3" class="text-right">Tarif unitar</v-col>
                        <v-col cols="3" class="text-right">
                            <span v-if="$vuetify.breakpoint.smAndUp">Valoare</span>
                            <span v-if="$vuetify.breakpoint.xs">Val</span>
                        </v-col>
                        <v-col cols="3" class="text-right">TVA</v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row no-gutters v-for="(detail, index) in item.items" :key="index" class="py-1">
                <v-col cols="4" md="6">{{ detail.name }}</v-col>
                <v-col cols="8" md="6">
                    <v-row no-gutters>
                        <v-col cols="3" class="text-center">{{ detail.quantity }}</v-col>
                        <v-col cols="3" class="text-right">
                            <im-value :value="detail.price_without_vat"></im-value>
                        </v-col>
                        <v-col cols="3" class="text-right">
                            <im-value :value="detail.total_price_without_vat"></im-value>
                        </v-col>
                        <v-col cols="3" class="text-right">
                            <im-value :value="detail.total_vat_value"></im-value>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row no-gutters class="py-2">
                <v-col md="6" offset-md="6" cols="7" offset="5">
                    <v-row no-gutters class="py-1">
                        <v-col xs6>Total partial</v-col>
                        <v-col cols="3" class="font-weight-bold text-right">
                            <im-value :value="item.total_without_vat"></im-value>
                        </v-col>
                        <v-col cols="3" class="font-weight-bold text-right">
                            <im-value :value="item.total_vat"></im-value>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="py-1">
                        <v-col xs6 class="font-weight-bold">Total de plata</v-col>
                        <v-col xs6 class="text-right">
                            <im-price :price="item.total"></im-price>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
    </v-card>
</div>
</template>

<script>
import defaults from "../utils/PropDefaults.js"
import IMPrice from '../small-components/IMPrice.vue';
import IMValue from '../small-components/IMValue.vue';

export default {
    components: {
        'im-price': IMPrice,
        'im-value': IMValue,
    },

    props: {
        item: {
            type: Object,
            default: defaults.invoice_item
        },
    },

    methods: {

        getTitle(value) {
            if(!value) {
                return
            }
            let type = value.toString()
                .split('-')[0];
            if(type == "HELLO") {
                return "Factura fiscala"
            } else if(type == "PRF") {
                return "Proforma"
            }
        },

        formatDate(date) {
            if(!date) return date;
            return this.$moment(String(date))
                .format('DD.MM.YYYY');
        },

        emitClick() {
            this.$emit('click');
        },

    },

}
</script>
